module.exports = __webpack_public_path__ + "img/6805c0f8-c6dd-4233-af24-36eb009a4931.f10db518.jpg";